let cashback = require('./cashback').default;
let captcha = require('./captcha').default;

module.exports = () => {
    $.ajaxPrefilter(options => {
        if (options.data instanceof FormData) {
            options.data.append('fromUrl', location.pathname)
        } else {
            options.data = ((options.data || '') + '&fromUrl=' + location.pathname).replace(/^&/, '')
        }
    })

    $.fancybox.defaults = {...$.fancybox.defaults, ...{
        lang: 'ru',
        hash: false,
        buttons: [
            'zoom',
            'slideShow',
            'fullScreen',
            'download',
            'thumbs',
            'close'
        ],
        autoFocus: false,
        i18n: {
            ru: {
                CLOSE: 'Закрыть',
                NEXT: 'Следующая',
                PREV: 'Предыдущая',
                ERROR: 'Ошибка загрузки :( <br> Попробуйте позже :)',
                PLAY_START: 'Начать слайдшоу',
                PLAY_STOP: 'Остановить слайдшоу',
                FULL_SCREEN: 'Полный экран',
                THUMBS: 'Миниатюры',
                DOWNLOAD: 'Скачать',
                SHARE: 'Поделиться',
                ZOOM: 'Увеличить'
            }
        },
        caption(instance, slide) {
            return slide.opts.$orig ? slide.opts.$orig.attr('title') : '';
        },
        beforeLoad(instance, slide) {
            switch (slide.contentType) {
                case 'html':
                    slide.opts.touch = false;
                    break;
                case 'image':
                    if (!$app.isModerator) {
                        slide.opts.protect = true;
                        $('.fancybox-button--download', instance.$refs.toolbar).remove();
                    }
                    break;
            }
        },
        afterShow(instance, slide) {
            if (slide.contentType === 'html') {
                cashback(slide.$content[0]);
                $app.form.svobodaStola(slide.opts.$orig);
                $helpers.initTooltips(slide.$content);
                slide.$content.find('#bron-form').processBronForm(slide.opts.$orig);

                let form = slide.$content.find('form:not(#bron-form,#svobodastola-form,#formAuth,#formReg,.filters)').easyValidate(null, null, slide.opts.$orig)[0]

                captcha(form)
            }

            if (slide.contentType === 'image' && slide.opts.$orig[0].classList.contains('swiper-slide')) {
                slide.opts.$orig[0].parentNode.parentNode.swiper.slideTo(instance.currIndex)
            }
        },
        afterClose(instance, slide) {
            let orig = slide.opts.$orig

            if (orig && orig.data('noLeavePlz')) {
                $.get($app.urlPrefix + '/bar/bron/noLeavePlz', {eventParam: 'from-noleaveplz', id: orig.data('id')}, form => {
                    $.fancybox.open(form)

                    orig.data('noLeavePlz', false)
                })
            }
        }
    }}

    $.fn.barrating.defaults = {...$.fn.barrating.defaults, ...{
        theme: 'bars-square'
    }}
};